import { render, staticRenderFns } from "./DataAnalysis.vue?vue&type=template&id=106a005e"
import script from "./DataAnalysis.vue?vue&type=script&lang=js"
export * from "./DataAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('106a005e')) {
      api.createRecord('106a005e', component.options)
    } else {
      api.reload('106a005e', component.options)
    }
    module.hot.accept("./DataAnalysis.vue?vue&type=template&id=106a005e", function () {
      api.rerender('106a005e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/DataAnalysis.vue"
export default component.exports